import { push } from 'react-router-redux'
import Api from '~/api'
import Store from 'store'
import { isLoading } from '~/form/actions'

export function login(email, password) {
  return dispatch => {
    Api.post('/auth/login', { email, password }).then(({ data = {} }) => {
      if (data.success) {
        dispatch(loginSuccess(data.authToken))
        dispatch(push('/'))
      } else {
        dispatch(loginFail(data.message))
        dispatch(isLoading('auth-login', false))
      }
    })
  }
}

export function loginSuccess(authToken) {
  Store.set('authToken', authToken)
  return {
    type: 'LOGIN_SUCCESS',
    authToken,
  }
}

export function loginFail(message) {
  return {
    type: 'LOGIN_FAIL',
    message,
  }
}

export function logout() {
  return dispatch => {
    Store.remove('authToken')
    dispatch({ type: 'LOGOUT' })
    dispatch(push('/login'))
  }
}

export function loadAuthUser() {
  return dispatch => {
    dispatch(authUserLoading(true))
    Api.get('/auth').then(({ data = {} }) => {
      dispatch(authUserLoading(false))
      if (data.success) {
        dispatch(setAuthUser(data.user))
      } else {
        dispatch(loadAuthUserFail(data.message))
      }

      // If this request returns new authToken, set it to store
      if (data.updateToken) {
        Store.set('authToken', data.updateToken)
        dispatch({
          type: 'UPDATE_AUTHTOKEN',
          authToken: data.updateToken,
        })
      }
    })
  }
}

export function authUserLoading(loading) {
  return {
    type: 'AUTH_USER_LOADING',
    loading,
  }
}

export function loadAuthUserFail(message) {
  return {
    type: 'SET_AUTH_USER_ERROR',
    message,
  }
}

export function setAuthUser(user) {
  return {
    type: 'SET_AUTH_USER',
    user,
  }
}
